import { Box, Button, Paper, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOnboarding } from '../../../contexts/OnboardingContext';

interface OnboardingCompletionModalProps {
  open: boolean;
  onClose: () => void;
}

const OnboardingCompletionModal = ({ open, onClose }: OnboardingCompletionModalProps) => {
  const { t } = useTranslation(['onboarding']);
  const theme = useTheme();
  const { exitSampleData } = useOnboarding();

  const handleExit = () => {
    exitSampleData();
    onClose();
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 56, // Above bottom navigation
        left: 0,
        right: 0,
        zIndex: theme.zIndex.modal + 200,
        px: 2,
        pb: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 2.5,
          position: 'relative',
          color: theme.palette.common.white,
          backgroundColor: 'pink.500',
        }}
      >
        {/* Content */}
        <Stack spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h6" component="span">
              👋
            </Typography>
            <Typography variant="subtitle1" fontWeight={700}>
              {t('exit_sample_data_title')}
            </Typography>
          </Stack>

          <Typography>
            {t('exit_sample_data_description')}
          </Typography>

          <Stack alignItems="flex-end">
            <Button
              size="small"
              variant="contained"
              onClick={handleExit}
              sx={{
                px: 4,
              }}
            >
              {t('exit')}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default OnboardingCompletionModal;
